<template>
    <div class="bell" v-if="bell" :id="bell.day_schedule_item_id">
        &nbsp;{{ formatted_time }} - {{ bell.description }}
    </div>
    <div class="bell" v-else>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: ['bell'],
    computed: {
        formatted_time() {
            return moment(this.bell.schedule_time, 'hh:mm a').format('hh:mm');
        }
    }
}
</script>

<style scoped>
.bell::before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #ddd;
}

.bell {
    text-align: left;
    min-height: 20px;
    font-size: small;
    margin-left: 4rem;
    overflow: hidden;
}

.bell.passed {
    opacity: 0.4;
}
</style> 